var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-skip-to-content'),_c('s-busy-global'),_c('s-modal'),_c('s-header'),_c('s-notification-center'),_c('s-main',[_c('router-view')],1),_c('s-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }